import { Outlet } from 'react-router-dom';
import MainHeader from './header';
import { Avatar, Button, Card, CardContent, Input, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { get, post, postImage } from 'api/apiBridges/httpBridge';
import { useDispatch, useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { Email, Margin } from '@mui/icons-material';
import Loading from 'components/Load';
import { enqueueSnackbar } from 'notistack';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { colors } from 'styles/colors';
import { onChangeUploadImage } from 'store/slices/uploadImage';
import useOn from 'components/socketLib/UseOn';
import EditIcon from '@mui/icons-material/Edit';
import UserAvatar from "../components/EIComponents/UserAvatar";
import { useLocalNotifications } from 'components/Events';

const AdminSettings = () => {

  const { user_id, role } = useSelector(
      loginSelector
  );

  const [loading, setLoading] = useState(true);
  const [changed, setChanged] = useState(false);
  const [user, setUser] = useState({
      email: "",  
      fio: "",
      mobile_number: "",
      photo: undefined
  })

  const { socket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const onSubmit = useCallback((data) => {
      dispatch(onChangeUploadImage(data));
  }, [dispatch]);

  const { showNotification } = useLocalNotifications();

  useEffect(() => {
    const fetchData = async () => {
        try {
        setLoading(true);
        const responseData = await get('Admins/get', {aid:user_id});
        if (responseData?.message) {
          let photo = undefined
          if (responseData.message.data) {
            let admindata = JSON.parse(responseData.message.data)
            photo = admindata?.photo
          }
          let obj = {
              email: responseData.message.email || "Не указано",  
              fio: responseData.message.fio || "Не указано",
              mobile_number: responseData.message.mobile_number || "Не указано",
              photo
          }
          setUser(obj)
        }
        } catch (err) {
        } finally {
        setLoading(false);
        }
    };

    fetchData();
  }, []); 

  const phoneRegex = /^\+7\d{10}$/;
  const emailRegex = /^.+@.+\..{2,}$/;

  const change = (path, val) => {
    // let finalValue = val;
    // if (path === 'mobile_number') {
    //   let rawValue = val.replace(/\s/g, '');
    //   let cleanedValue = rawValue.replace(/^(7|8)/, '+7');

    //   if (!cleanedValue.startsWith('+7')) {
    //     cleanedValue = rawValue.startsWith('+') 
    //       ? '+' + rawValue.slice(1).replace(/[^\d]/g, '') 
    //       : rawValue.replace(/[^\d+]/g, '');
    //     cleanedValue = cleanedValue.replace(/^(7|8)/, '+7');
    //   }

    //   cleanedValue = cleanedValue.replace(/[^\d+]/g, '');

    //   if (cleanedValue.startsWith('+7') && cleanedValue.length > 12) {
    //     cleanedValue = cleanedValue.substring(0, 12);
    //   } else if (cleanedValue.length > 11 && !cleanedValue.startsWith('+')) {
    //     cleanedValue = cleanedValue.substring(0, 11);
    //   }
    //   finalValue = cleanedValue;
    // }

    setUser(prev => ({ ...prev, [path]: val }));
    setChanged(true);
  };

  const save = () => {
    const isPhoneValid = user.mobile_number.trim() !== '' && user.mobile_number !== "Не указано"
    const isEmailValid = emailRegex.test(user.email);
    const isNameValid = user.fio.trim() !== '' && user.fio !== "Не указано";

    if (isNameValid && isPhoneValid && isEmailValid) {
      post('Admins/addupdate', {
        id: user_id, 
        fio: user.fio, 
        email: user.email, 
        mobile_number: user.mobile_number.replace(/\D/g, '')
      });
      socket.emit("userSettingsUpdateSet", {
        id: user_id, 
        fio: user.fio, 
        email: user.email, 
        mobile_number: user.mobile_number.replace(/\D/g, '')
      });
      setChanged(false);
      enqueueSnackbar('Настройки сохранены', { variant: 'success' });
    } else {
      if (!isNameValid) {
        showNotification({
              id: 'noName', 
              type: 'error', 
              message: 'Не введено имя' 
          });
      } else if (user.mobile_number == '') {
        showNotification({
              id: 'wrongNumber', 
              type: 'error', 
              message: 'Не введен номер' 
          });
      } else if (!isEmailValid) {
        showNotification({
              id: 'wrongEmail', 
              type: 'error', 
              message: 'Неправильно введена почта' 
          });
      } else {
        showNotification({
              id: 'noData', 
              type: 'error', 
              message: 'Недостаточно данных' 
          });
      }
    }
  };

  const handleFileUpload = useCallback(async (event) => {
      let selectedFiles = Array.from(event.target.files);
      if (selectedFiles) {
        let rightFiles = []
        selectedFiles.map((file) => {
          if (file.type === "image/png" || file.type === "image/jpeg") {
            rightFiles.push(file)
          }
          else {
            console.log(file.type)
            showNotification({
              id: 'uploadDealImageErr', // Уникальный идентификатор
              type: 'error', // Тип уведомления
              message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
            });
          }
        })
        if (rightFiles.length > 0 ) {
          onSubmit({ upload: true });
          // enqueueSnackbar('Загрузка изображения...', { variant: 'info', autoHideDuration: 5000 });
          showNotification({
            id: 'uploadASImage', // Уникальный идентификатор
            type: 'info', // Тип уведомления
            message: 'Загрузка' // Текст сообщения
          });

          postImage(rightFiles, socket.id, {user_id, role, content_type:"uploadAvatar"}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
        }
      }
  }, [onSubmit]);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  if (loading) {
      return <Loading></Loading>
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', width: '50%', height: '100%', overflow: 'hidden' }}>
      <Card sx={{ borderRadius: 3, boxShadow: 5, margin: "15px"}}>
        <Typography variant="h1" style={{ marginLeft: 15, marginTop: "10px"}}>НАСТРОЙКИ ПРОФИЛЯ</Typography>
        <CardContent>                  
          <div style={{display: 'flex', flexDirection: 'row', justifyContent:'flex-start', alignItems: "flex-end"}}>
            <UserAvatar src={user.photo} userData={user} user_id={user_id} size={68} marginRight="5px"/>
            <input
                type="file"
                multiple
                accept="application/png"
                style={{ display: "none" }}
                id="upload-avatar"
                onChange={handleFileUpload}
            />
            <label htmlFor="upload-avatar">
                <EditIcon ></EditIcon>
            </label>
          </div>
        </CardContent>
        <CardContent style={{ marginLeft: 5}}>                  
          <Typography variant="body1" >ФИО:</Typography>
          <Input value={user.fio} onChange={(event) => change('fio', event.target.value)}/>
        </CardContent>
        <CardContent style={{ marginLeft: 5}}>
          <Typography variant="body1" >Email:</Typography>
          <Input value={user.email} onChange={(event) => change('email', event.target.value)}/>
        </CardContent>
        <CardContent style={{ marginLeft: 5}}>
          <Typography variant="body1" >Контактный телефон:</Typography>
          <Input value={user.mobile_number} placeholder="+7xxxxxxxxxx" onChange={(event) => change('mobile_number', event.target.value)}/>            
        </CardContent>
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '95%', paddingBottom:'15px' }}>
            {changed? <Button 
                onClick={save}
                variant="contained" 
                sx={{ 
                textTransform: 'none', 
                backgroundColor: colors.elements, 
                fontWeight: 'bold', 
                marginRight: '10px' 
                }} 
            >
                Применить
            </Button> : null}
        </div>
      </Card>
    </div>
  );
};

export default AdminSettings;
